// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { RbFragmentDoc } from '../../graphql/api/ring-builder/rb.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderDocument = gql`
    query ringBuilder($locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!) {
  ringBuilder(input: {region: $region, currency: $currency}) {
    ...rb
  }
}
    ${RbFragmentDoc}`;

export function useRingBuilderQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.RingBuilderQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.RingBuilderQuery, SchemaTypes.RingBuilderQueryVariables | undefined>({ query: RingBuilderDocument, variables: undefined, ...options });
};